import {Evaluator} from "@cm/graph-v3"
import {registerImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/register-image-op-node"
import {Size2, Vector2} from "@cm/math"
import {definition} from "@app/textures/texture-editor/operator-stack/operators/tiling/node/extract-border/definition"
import {AnyImageOpContext, ImageOpOutputs} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {ImageOpNodeExtractRegion} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/primitive/extract-region/node"
import {ImageOpNodeBag} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/image-op-node-bag"
import {CompositeImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/composite-image-op-node"

const nodeDefinition = {...definition, nodeClass: "ImageOpNodeTilingExtractBorder"}

@registerImageOpNode
export class ImageOpNodeTilingExtractBorder extends CompositeImageOpNode<typeof definition> {
    override get definition() {
        return nodeDefinition
    }

    override async execute(evaluator: Evaluator<AnyImageOpContext>, imageOpNodeBag: ImageOpNodeBag): Promise<ImageOpOutputs<typeof definition>> {
        const {mappedImage, borderDirection, borderBlendDistance} = await evaluator.getAll(this.parameters)
        const borderImageSize = new Size2(
            borderDirection === "horizontal" ? mappedImage.descriptor.width : borderBlendDistance,
            borderDirection === "vertical" ? mappedImage.descriptor.height : borderBlendDistance,
        )
        const combinedBorderImageSize = borderImageSize.mul({
            width: borderDirection === "horizontal" ? 1 : 2,
            height: borderDirection === "vertical" ? 1 : 2,
        })

        // low border
        const lowBorder = imageOpNodeBag.getNode("lowBorderView", ImageOpNodeExtractRegion, {
            sourceImage: mappedImage,
            region: {
                ...Vector2.zero,
                ...combinedBorderImageSize,
            },
        })

        // high border
        const highBorder = imageOpNodeBag.getNode("highBorderView", ImageOpNodeExtractRegion, {
            sourceImage: mappedImage,
            region: {
                ...Vector2.fromSize2Like(mappedImage.descriptor).subInPlace(Vector2.fromSize2Like(combinedBorderImageSize)),
                ...combinedBorderImageSize,
            },
        })

        return await evaluator.getAll({
            lowBorder,
            highBorder,
        })
    }
}
